import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { InputProps } from './types';
import { styles } from './styles';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, required, icon, className, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="tw-w-full">
        {label && (
          <label htmlFor={inputId} className={styles.label}>
            {label}
            {required && <span className={styles.requiredIndicator}>*</span>}
          </label>
        )}
        <div className="tw-relative">
          {icon && <div className={styles.iconContainer}>{icon}</div>}
          <input
            ref={ref}
            id={inputId}
            className={clsx(
              styles.base,
              styles.focus,
              icon ? styles.withIconPadding : styles.defaultPadding,
              error ? styles.error : styles.defaultBorder,
              props.disabled && styles.disabled,
              className
            )}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined}
            required={required}
            {...props}
          />
        </div>
        {error && (
          <p id={`${inputId}-error`} className={styles.errorMessage}>
            {error}
          </p>
        )}
        {hint && !error && (
          <p id={`${inputId}-hint`} className={styles.hint}>
            {hint}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export type { InputProps } from './types';
export default Input;
